import React from 'react'
import { DrillsCategoriesLoader } from 'loaders'
import PropTypes from 'prop-types'
import ActivityCreateContainer from '../../containers/ActivityCreateContainer'

const ActivityCreatePage = ({ history, match, location }) => (
  <DrillsCategoriesLoader>
    <ActivityCreateContainer
      history={history}
      match={match}
      location={location}
    />
  </DrillsCategoriesLoader>
)

ActivityCreatePage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({}).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default ActivityCreatePage
